/* eslint-disable */
import {
  Flex,
  Icon,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Input,
  Button,
  Select,
  HStack,
} from "@chakra-ui/react";
// Custom components
import { useDispatch, useSelector } from "react-redux";
import Card from "components/card/Card";
import React, { useState, useEffect, useMemo, useRef } from "react";
import {
  usePagination,
  useSortBy,
  useTable,
  useFilters,
  useAsyncDebounce,
} from "react-table";
import moment from "moment";
import { downloadExcel } from "react-export-table-to-excel";
import {
  convertDateToLocal,
  isNotEmptyData,
  convertCallDurationToMin,
} from "../../../../utils/Utils";
import {
  MdPlayArrow,
  MdDownload,
  MdEdit,
  MdPhone,
  MdLockClock,
  MdCloudDownload,
  MdDelete,
  MdDisabledByDefault,
} from "react-icons/md";
import Window from "floating-window-ui";
import {
  postOTPToUser,
  downloadBlobFile,
} from "../../../../redux/actions/initiateCall";
import { openModal } from "../../../../redux/actions/modal";

export default function InitiateCallTable(props) {
  const { title, columnsData, tableData, isEvening, updateAnalyticsValue } =
    props;
  let dispatch = useDispatch();
  const columns = useMemo(() => columnsData, [columnsData]);
  const tb = useMemo(() => tableData, [tableData]);
  const [data, setData] = useState([]);
  const [allDataWithoutFilter, setAllDataWithoutFilter] = useState([]);
  const [paginationPageValue, setPaginationPageValue] = useState(0);
  const [highlightEditingRow, setHighlightEditingRow] = useState(null);

  const UTC_DATE_TIME_FORMAT = "YYYY-MM-DDTHH:mm:ss.SSS[Z]";

  const tableInstance = useTable(
    {
      columns,
      data: tb,
      // initialState: { pageIndex: paginationPageValue, pageSize: 5 },
      initialState: { pageIndex: 0, pageSize: 5 },
    },
    useFilters,
    useSortBy,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    state,
    initialState,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = tableInstance;
  initialState.pageSize = 5;

  const textColor = useColorModeValue("secondaryGray.900", "white");
  const iconColor = useColorModeValue("#2185d0");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isOpenEdit, setIsOpenEdit] = useState(false);
  const [audioVisibility, setAudioVisibility] = useState(false);

  const [audioUrl, setAudioUrl] = useState("");
  const [valSelectedColForEdit, setSelectedColForEdit] = useState({});
  const editValueRefOne = useRef(null);
  const editValueRefTwo = useRef(null);
  const editValueRefThree = useRef(null);
  const editValueRefFour = useRef(null);

  const audioRef = useRef(null);
  const [custFilterValue, setCustFilterValue] = useState({});

  // console.log("Page tbl",tableData);
  // console.log("Page nos",pageCount)

  const checkCallCanBeStartedOrNot = (rowData) => {
    console.log("Check call can be started or not", rowData);
    if (
      rowData.original &&
      rowData.original.callInitiation &&
      (rowData.original.callInitiation.title === "Scheduled" ||
        rowData.original.callInitiation.title === "Processed")
    ) {
      return;
    } else {
      console.log("in else condition");
      props.onClickStartCallNow(rowData);
    }
  };

  const shouldShowEditCallTimeIcon = (rowData) => {
    if (
      rowData.original.callInitiation.title === "Processed" ||
      (rowData.original.status &&
        rowData.original.status.isProcessed === false) ||
      rowData.original.callInitiation.title === "Processing"
    ) {
      return false;
    } else {
      return true;
    }
  };

  return (
    <div className="uploadDetailBottom">
      <Card
        className="uploadCard"
        direction="column"
        mh="400px"
        w="100%"
        px="0px"
        style={{ paddingTop: "0px" }}
      >
        <div className="initiateCallTable">
          <Table
            className="icMainTable"
            {...getTableProps()}
            m="0px auto 10px"
            size="sm"
            variant="striped"
            colorScheme="blackAlpha"
            // display="block"
          >
            <Thead>
              {headerGroups.map((headerGroup, index) => (
                <Tr key={index}>
                  {headerGroup.headers.map((column, index) => {
                    return (
                      <Th
                        // {...column.getHeaderProps(column.getSortByToggleProps())}
                        pe="10px"
                        key={index}
                        borderColor={borderColor}
                      >
                        <Text
                          fontSize="15px"
                          textTransform="none"
                          fontFamily="sans-serif"
                          marginBottom="0px"
                        >
                          {column.Header}
                        </Text>
                      </Th>
                    );
                  })}
                </Tr>
              ))}
            </Thead>
            <Tbody {...getTableBodyProps()} overflow="auto">
              {page.map((row, rowindex) => {
                // console.log("Row",row)
                prepareRow(row);
                return (
                  <Tr
                    {...row.getRowProps()}
                    key={rowindex}
                    style={{
                      border:
                        highlightEditingRow === rowindex
                          ? "solid #000000"
                          : null,
                    }}
                  >
                    {row.cells.map((cell, index) => {
                      // console.log("cell",cell)
                      let data = "";
                      if (cell.column.id === "download") {
                        data = (
                          <>
                            <p style={{ color: "#2185d0", fontSize: "1.5vw" }}>
                              <MdCloudDownload
                                onClick={() => {
                                  console.log("Download file", row);
                                  let filepayload = {
                                    uploadedName: row.original.uploadedFileName,
                                  };
                                  dispatch(downloadBlobFile(filepayload));
                                }}
                              />
                            </p>
                          </>
                        );
                      } else if (cell.column.id === "status") {
                        // console.log("Status====>", cell.value);
                        let statusData = "pending";
                        if (cell.value && cell.value.isProcessed === true) {
                          statusData = { status: "processed", color: "green" };
                        } else if (cell.value && cell.value.error) {
                          statusData = { status: "error", color: "red" };
                        } else {
                          statusData = { status: "pending", color: "orange" };
                        }
                        data = (
                          <>
                            <div
                              style={{
                                width: "20px",
                                height: "20px",
                                backgroundColor: statusData.color,
                                borderRadius: "50%",
                              }}
                              class="dot"
                            ></div>
                          </>
                        );
                      } else if (cell.column.id === "scheduledTime") {
                        let shouldShowEditIcon =
                          shouldShowEditCallTimeIcon(row);
                        data = (
                          <>
                            <span
                              className="editText"
                              style={{ display: "flex" }}
                            >
                              <Text
                                style={{ width: "120px" }}
                                color={textColor}
                                fontSize="sm"
                                fontWeight="700"
                              >
                                {cell.value}
                              </Text>
                              {shouldShowEditIcon ? (
                                <Icon
                                  w="18px"
                                  h="18px"
                                  me="5px"
                                  style={{
                                    display: "inline-block",
                                    marginLeft: "10px",
                                  }}
                                  _hover={{ cursor: "pointer" }}
                                  _focus={{ boxShadow: "outline" }}
                                  as={MdEdit}
                                  color="#000000"
                                  onClick={() => {
                                    props.setShowEditCallTimeModal(true);
                                    props.setScheduletimeDetails(row);
                                  }}
                                />
                              ) : null}
                            </span>
                          </>
                        );
                      } else if (cell.column.id === "callInitiation") {
                        // console.log("Button cell value", cell);

                        data = (
                          <>
                            <Button
                              onClick={() => {
                                if (cell.value.title !== "Check error") {
                                  checkCallCanBeStartedOrNot(row);
                                } else {
                                  let errorMsgArr = cell.value.errorList;
                                  let errMsg = "";
                                  for (let i = 0; i < errorMsgArr.length; i++) {
                                    errMsg =
                                      errMsg + ", " + errorMsgArr[i] + "";
                                  }
                                  dispatch(openModal(`Error in - ${errMsg}`));
                                }
                              }}
                              style={{
                                color: "#000000",
                                backgroundColor: cell.value.color,
                                width: "70%",
                                borderRadius: "5px",
                              }}
                              fontSize="sm"
                              fontWeight="700"
                            >
                              <p style={{ padding: "15px" }}>
                                {cell.value.title}
                              </p>
                            </Button>
                          </>
                        );
                      } else if (cell.column.id === "callCancellation") {
                        // console.log("Button cell value", cell);
                        const isStopped = cell.row.original.isCallStopped;

                        data = (
                          <>
                            <Button
                              onClick={() => {
                                if (!isStopped) {
                                  props.stopCallForParticularFileAndWorkFlow(
                                    cell
                                  );
                                }
                              }}
                              style={{
                                color: "#000000",
                                backgroundColor: isStopped
                                  ? "#f44336"
                                  : "#fbbd08",
                                width: "70%",
                                borderRadius: "5px",
                              }}
                              fontSize="sm"
                              fontWeight="700"
                            >
                              <p style={{ padding: "15px" }}>
                                {isStopped ? "Call stopped" : "Stop call"}
                              </p>
                            </Button>
                          </>
                        );
                      } else if (cell.column.id === "callOnGoingStatus") {
                        // console.log("Button cell value", cell)
                        data = (
                          <>
                            <Button
                              style={{
                                color: "#000000",
                                backgroundColor: "#70d5fa",
                                width: "70%",
                                borderRadius: "5px",
                              }}
                              fontSize="sm"
                              fontWeight="700"
                            >
                              <p style={{ padding: "15px" }}>{cell.value}</p>
                            </Button>
                          </>
                        );
                      } else if (cell.column.id === "moreDetails") {
                        console.log("Button cell value", cell);
                        data = (
                          <>
                            <Button
                              onClick={() =>
                                props.checkLiveDataForABatch(
                                  cell?.row?.original
                                )
                              }
                              style={{
                                color: "#000000",
                                backgroundColor: "#ffc107",
                                width: "70%",
                                borderRadius: "5px",
                              }}
                              fontSize="sm"
                              fontWeight="700"
                            >
                              <p style={{ padding: "15px" }}>Check</p>
                            </Button>
                          </>
                        );
                      } else if (cell.column.id === "callReinitiation") {
                        console.log("Button cell value", cell);
                        data = (
                          <>
                            <Button
                              onClick={() => {
                                props.setModalCallReInitiation(true)
                              }}
                              style={{
                                color: "#000000",
                                backgroundColor: "#b3b5e8",
                                width: "100%",
                                borderRadius: "5px",
                              }}
                              fontSize="sm"
                              fontWeight="700"
                            >
                              <p style={{ padding: "15px" }}>
                                Setup Reinitiation
                              </p>
                            </Button>
                          </>
                        );
                      } else if (cell.column.id === "disableFile") {
                        data = (
                          <>
                            <p style={{ color: "#f44336", fontSize: "2.5vw" }}>
                              <MdDisabledByDefault
                                onClick={() => {
                                  props.setSelectedFileToDisable(
                                    cell.row.original
                                  );
                                  props.setPopupForDisableFile(true);
                                }}
                              />
                            </p>
                          </>
                        );
                      } else {
                        data = (
                          <>
                            <Text
                              color={textColor}
                              fontSize="sm"
                              fontWeight="700"
                            >
                              {cell.value}
                            </Text>
                          </>
                        );
                      }
                      return (
                        <Td
                          {...cell.getCellProps()}
                          key={index}
                          fontSize={{ sm: "14px" }}
                          minW={{ sm: "150px", md: "20px", lg: "auto" }}
                          maxW={{ sm: "200px", md: "200px", lg: "150px" }}
                          borderColor="transparent"
                        >
                          {data}
                        </Td>
                      );
                    })}
                  </Tr>
                );
              })}
            </Tbody>
          </Table>
        </div>
        <div className="pagination" style={{ margin: "25px 30px 0px 25px" }}>
          <HStack className="bottomPagination">
            <div className="pageChangeBtn">
              <Button
                size="sm"
                onClick={() => {
                  gotoPage(0);
                  setPaginationPageValue(0);
                }}
                disabled={!canPreviousPage}
              >
                {"<<"}
              </Button>{" "}
              <Button
                size="sm"
                onClick={() => {
                  previousPage();
                  setPaginationPageValue(paginationPageValue - 1);
                }}
                disabled={!canPreviousPage}
              >
                {"<"}
              </Button>{" "}
              <Button
                size="sm"
                onClick={() => {
                  nextPage();
                  setPaginationPageValue(paginationPageValue + 1);
                }}
                disabled={!canNextPage}
              >
                {">"}
              </Button>{" "}
              <Button
                size="sm"
                onClick={() => {
                  gotoPage(pageCount - 1);
                  setPaginationPageValue(pageCount - 1);
                }}
                disabled={!canNextPage}
              >
                {">>"}
              </Button>{" "}
            </div>
            <div className="pageCounter">
              <Text fontSize="sm">
                Page{" "}
                <strong>
                  {pageIndex + 1} of {pageOptions.length}
                </strong>{" "}
              </Text>
              <span>|</span>
              <Text fontSize="sm">
                Go to page:{" "}
                <Input
                  type="number"
                  defaultValue={pageIndex + 1}
                  onChange={(e) => {
                    const page = e.target.value
                      ? Number(e.target.value) - 1
                      : 0;
                    gotoPage(page);
                    setPaginationPageValue(page);
                  }}
                  variant="filled"
                  size="xs"
                  width="20%"
                />
              </Text>
              <Select
                value={pageSize}
                onChange={(e) => {
                  setPageSize(Number(e.target.value));
                }}
                variant="filled"
                size={"xs"}
                width={"auto"}
              >
                {[5, 10, 50].map((pageSize) => (
                  <option key={pageSize} value={pageSize}>
                    Show {pageSize}
                  </option>
                ))}
              </Select>
            </div>
          </HStack>
        </div>

        {isOpen && (
          <Window
            id="react-window-audio"
            resizable={true}
            height={150}
            width={600}
            titleBar={{
              title: "Call Recording",
              buttons: {
                minimize: false,
                maximize: false,
                close: () => {
                  if (
                    audioRef &&
                    audioRef.current &&
                    audioRef.current.pause()
                  ) {
                    audioRef.current.pause();

                    audioRef.current.load();
                  }
                  onClose();
                  setAudioVisibility(false);
                },
              },
            }}
          >
            {/* controlsList="nodownload" */}
            <figure style={{ margin: "10px auto" }}>
              <audio
                preload="auto"
                src={audioUrl}
                onCanPlayThrough={() => triggerOtherAudioDisplay()}
              ></audio>
              {audioVisibility ? (
                <audio
                  controls
                  style={{ width: "100%" }}
                  src={audioUrl}
                  ref={audioRef}
                >
                  {/* <a href="/media/cc0-audio/t-rex-roar.mp3">Download audio</a> */}
                </audio>
              ) : null}
            </figure>
          </Window>
        )}

        {isOpenEdit && (
          <Window
            id="react-window-audio"
            height={440}
            width={600}
            resizable={true}
            titleBar={{
              title: "Analytics Data Editing",
              buttons: {
                minimize: false,
                maximize: false,
                close: () => {
                  onCloseEdit(false);
                  setAudioVisibility(false);
                  setHighlightEditingRow(null);
                },
              },
            }}
          >
            <div className="editAudioModal">
              <div className="infoHeader">
                <div className="phoneNumb">
                  <Icon
                    w="16px"
                    h="16px"
                    me="5px"
                    _hover={{ cursor: "pointer" }}
                    _focus={{ boxShadow: "outline" }}
                    as={MdPhone}
                    color={iconColor}
                    onClick={() => {}}
                  />
                  <Text>{`${valSelectedColForEdit.value.phoneNumber} (${valSelectedColForEdit.value.sessionId})`}</Text>
                </div>
                <div className="timeCircle">
                  <Icon
                    w="16px"
                    h="16px"
                    me="5px"
                    _hover={{ cursor: "pointer" }}
                    _focus={{ boxShadow: "outline" }}
                    as={MdLockClock}
                    color={iconColor}
                    onClick={() => {}}
                  />
                  <Text>{valSelectedColForEdit.value.timestamp}</Text>
                </div>
              </div>

              <div className="editAudio">
                <figure style={{ margin: "10px auto" }}>
                  <audio
                    preload="auto"
                    src={valSelectedColForEdit.value.callRecording}
                    onCanPlayThrough={() => triggerOtherAudioDisplay()}
                  ></audio>
                  {audioVisibility ? (
                    <audio
                      controls
                      style={{ width: "100%" }}
                      src={valSelectedColForEdit.value.callRecording}
                      ref={audioRef}
                    >
                      {/* <a href="/media/cc0-audio/t-rex-roar.mp3">Download audio</a> */}
                    </audio>
                  ) : null}
                </figure>
              </div>
              <div className="editOptions">
                {isEvening && (
                  <div className="formGroup">
                    <div className="rowBlock">
                      <label className="colLeft">{columnsData[5].Header}</label>
                      <div className="colRight">
                        <Input
                          className="form-control"
                          ref={editValueRefFour}
                          variant="filled"
                          size="lg"
                          placeholder={"Value"}
                          width="auto"
                        />
                      </div>
                    </div>
                  </div>
                )}
                <div className="formGroup">
                  <div className="rowBlock">
                    <label className="colLeft">
                      {isEvening
                        ? columnsData[6].Header
                        : columnsData[5].Header}
                    </label>
                    <div className="colRight">
                      <Input
                        className="form-control"
                        ref={editValueRefOne}
                        variant="filled"
                        size="lg"
                        placeholder={"Value"}
                        width="auto"
                      />
                    </div>
                  </div>
                </div>
                <div className="formGroup">
                  <div className="rowBlock">
                    <label className="colLeft">
                      {isEvening
                        ? columnsData[7].Header
                        : columnsData[6].Header}
                    </label>
                    <div className="colRight">
                      <Input
                        className="form-control"
                        ref={editValueRefTwo}
                        variant="filled"
                        size="lg"
                        placeholder={"Value"}
                        width="auto"
                      />
                    </div>
                  </div>
                </div>
                <div className="formGroup">
                  <div className="rowBlock">
                    <label className="colLeft">
                      {isEvening
                        ? columnsData[9].Header
                        : columnsData[7].Header}
                    </label>
                    <div className="colRight">
                      <Input
                        className="form-control"
                        ref={editValueRefThree}
                        variant="filled"
                        size="lg"
                        placeholder={"Value"}
                        width="auto"
                      />
                    </div>
                  </div>
                </div>
                <div className="formGroup textAlignRight">
                  <Button
                    colorScheme="blue"
                    mr={3}
                    onClick={() => {
                      onCloseEdit(true);
                      setHighlightEditingRow(null);
                    }}
                  >
                    Save
                  </Button>
                </div>
              </div>
            </div>
          </Window>
        )}


      </Card>
    </div>
  );
}
